'use client';

import React, { createContext, useContext, useState } from 'react';
import SectorRepository from './SectorRepository';
import { getContainer } from '@framework/di/getContainer';
import { ISector } from './Sector';

export interface ISubSector {
  sectorName: string,
  subSectorName: string,
  sectorColor: string,
  sectorAbbreviation: string,
  subSectorId: string,
}

const useSector = () => {
  const container = getContainer();
  const [subSectorList, setSubSectorList] = useState<Map<string, ISubSector>>(new Map<string, ISubSector>());

  const getSectorList = async (): Promise<void> => {
    const sectorRepository = container.get<SectorRepository>(SectorRepository);
    const payload: ISector[] = await sectorRepository.list();

    const subSectorList = new Map<string, ISubSector>();

    payload.forEach(
      (sector) => sector.subsectorList.forEach(
        (subSector) => {
          subSectorList.set(subSector.id, {
            sectorName: sector.name,
            subSectorName: subSector.name,
            sectorColor: sector.color,
            sectorAbbreviation: sector.abbreviation,
            subSectorId: subSector.id,
          });
        },
      ),
    );

    setSubSectorList(subSectorList);
  };

  return {
    subSectorList,
    getSectorList,
  };
};

type SectorContextType = ReturnType<typeof useSector>;

// @ts-ignore TODO: FIN-32798 strictNullChecks
export const SectorContext = createContext<SectorContextType>(null);

export const useSectorContext = () => {
  const context = useContext(SectorContext);
  if (!context) {
    throw new Error('useSectorContext must be used within a SectorContextProvider');
  }
  return context;
};

interface IProps {
  children: React.ReactNode,
}

const SectorContextProvider = ({ children }: IProps) => (
  <SectorContext.Provider value={ useSector() }>
    { children }
  </SectorContext.Provider>
);

export default SectorContextProvider;
